<template>

    <m-edit1/>

    <m-single-product-201 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard309","relatedCourse":false,"galleryFullSlider":false},...{}}' :style='""' class="my-3 container" >
                <template #default>   </template>
                </m-single-product-201>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct201 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
